module.exports = __webpack_public_path__ + "static/media/clipboard-user.07b8be3f.svg";